import {
  TicketRecipientInfo,
  TicketFileInfo,
  TicketUploadedFileInfo,
  TicketCreatorInfo,
  TicketValidityInfo,
  TicketSecurityInfo
} from "@/models/entities/ModelHelpers";
import {TicketType, TicketStatus, TicketFilterCriteria} from "@/utilities/enums/Enums";
import Recipient from "@/models/entities/Recipient";
import RecipientList from "@/models/entities/RecipientList";
import {getGermanIsoString} from "@/utilities/helpers/GermanIsoStringHelper";

export default class Ticket {
  id: number = -1;
  type: TicketType = TicketType.download;
  urlToken: string = '';
  shareUrl: string = '';
  recipient: TicketRecipientInfo = new TicketRecipientInfo();
  recipients: Array<Recipient> = [];
  recipientlists: Array<RecipientList> = [];
  file?: TicketFileInfo|null = null;
  uploadedFiles?: Array<TicketUploadedFileInfo> | null = null;
  creator: TicketCreatorInfo = new TicketCreatorInfo();
  message?: string|null = null;
  validity: TicketValidityInfo = new TicketValidityInfo();
  security: TicketSecurityInfo = new TicketSecurityInfo();
  status: TicketStatus = TicketStatus.active;
  createdAt: string = getGermanIsoString();
  modifiedAt?: string | null = null;
  modifiedBy?: string|null = null;
  filterCriteria: TicketFilterCriteria|null = null;
  filterValue: string|null = null;

  //helper props
  newRecipient: Recipient = new Recipient();

  constructor(data: Record<string, any> | undefined = undefined) {
    Object.assign(this, data);

    if (!this.newRecipient) {
      this.newRecipient = new Recipient();
    }
  }
}